import styled from "styled-components";

export const RadioItem = styled.div`
  min-height: 0;
  margin-bottom: 0;
  padding-left: 34px;
  font-size: 1.1875rem;
  line-height: 1.31579;
  font-weight: 400;
  display: block;
  position: relative;
`;
